import { WeekDayName } from './types';

export const weekDayNames: WeekDayName[] = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
